import { SET_LOGIN_PHONE } from 'actions';
import { IPhonePartial } from 'typings';

export function setLoginPhone(loginPhone: IPhonePartial) {
  return { loginPhone, type: SET_LOGIN_PHONE };
}
